import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import dynamic from 'next/dynamic';
const GetCustomProposal = dynamic(() => import('../../components/proposal/ppc/GetCustomProposal'));
const GetOrderProposal = dynamic(() => import('../../components/proposal/ppc/OrderNow'));

const PPCPlansSLider = props => {
  const [showCostumProposalModel, setShowCostumProposalModel] = useState(false);
  const [service, setService] = useState('Paid Advertising Services');
  const [budget, setBudget] = useState(0);
  const [plan, setPlan] = useState(0);
  const hideCostumProposalModal = () => {
    setShowCostumProposalModel(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const SampleNextArrow = props => {
    const { className, style, onClick } = props;
    return (
      <div className="cursor-pointer absolute" style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }} onClick={onClick}>
        <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
      </div>
    );
  };

  const SamplePrevArrow = props => {
    const { className, style, onClick } = props;
    return (
      <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
        <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
      </div>
    );
  };
  var settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1,
          arrows: false,
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };
  return (
    <>
      <style>{`
                .slick-slide {
                                outline: none
                            }
                            .slick-slide div {
                                outline: none
                            }
                            .slick-slide:focus,.slick-slide a{
                                outline: none;
                            }
                             @keyframes slide1 {
  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(10px, 0);
  }
}
                    .jello-horizontal {
                          animation: slide1 1s ease-in-out infinite;
                         // margin-left: 9px;
                    }
                    .shad>div{
                        box-shadow: 0px 1px 8px 1px rgba(0, 0, 0, 0.07);
                    }
            `}</style>
      <Slider {...settings} className="relative z-10 mt-20 -mx-10 md:mx-0">
        <div className=" p-10 md:p-15 shad ">
          <div className={'rounded-25'}>
            <div className="rounded-t-25 bg-gray h-296 text-center">
              <p className="pt-20 text-center font-bolder text-24 text-black">
                Plan For Start <br /> Growth
              </p>
              <img
                className="inline-block mx-auto mt-25"
                src="https://admin.weprodigi.com/uploads/files/shares/ppc/plan1.png"
                height={60}
                alt="plan1"
              />
              <p className="text-24 text-purple font-800 ">{props.total1} </p>
              <p className="text-16 text-purple italic font-bold"> / Monthly Ad Investment</p>
              <p className=" text-16 font-medium max-w-300 mx-auto mt-10 ">{props.total4} management fee</p>
            </div>

            <div className="min-h-820  bg-white flex flex-col items-start self-center rounded-b-25">
              <a
                className="max-w-300 mx-15 cursor-pointer hover:bg-green-hover  md:mx-0 w-full hidden md:flex items-center justify-center  mt-15 rounded-5 h-40  bg-green-badge text-white text-18 self-center"
                onClick={() => {
                  setBudget(props.total1);
                  setPlan(1);
                  setService('Plan For Start Growth');
                  setShowCostumProposalModel(true);
                  document.documentElement.style.overflow = 'hidden';
                }}
              >
                I'm ready to invest
              </a>
              <a
                className="max-w-300 cursor-pointer hover:bg-green-hover mx-15 md:mx-0 px-15 flex md:hidden items-center justify-center   mt-15 rounded-5 h-40 bg-green-badge text-white text-18 self-center"
                href={'/paid-advertising-services/order-now?service=' + service + '&budget=' + props.total1}
              >
                I'm ready to invest
              </a>
              <div className="max-w-300 w-90p flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">{props.total1}/month ad spend (paid to networks)</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Guaranteed Leads or Purchases</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Campaign development & strategy</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Keyword research and selection</span>
              </div>

              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Industry analysis</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad campaign copywriting</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad Banners Creation (2 banners)</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad Performance Testing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Google analytics integration & goal tracking</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Strategic bid management</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Remarketing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Monthly Reports & Consultation</span>
              </div>
            </div>
          </div>
        </div>
        <div className="p-10 md:p-15 shad">
          <div className={'rounded-25'}>
            <div className="rounded-t-25 bg-red-smmSlideTwo h-296 text-center">
              <p className="pt-20 text-center font-bolder text-24 text-black">
                Plan For Fast <br /> Growth
              </p>
              <img className="inline-block mx-auto" src="https://admin.weprodigi.com/uploads/files/shares/ppc/plan2.png" height={20} alt="plan2" />
              <p className="text-24 text-purple font-800 mt-13 ">{props.total2} </p>
              <p className="text-16 text-purple italic font-bold"> / Monthly Ad Investment</p>
              <p className=" text-16 font-medium max-w-300 mx-auto mt-10 ">10% management fee from ad spends</p>
            </div>
            <div className="min-h-820 bg-white flex flex-col items-start rounded-b-25 pb-20">
              <a
                className="max-w-300 cursor-pointer hover:bg-green-hover mx-15 md:mx-0 w-full hidden md:flex items-center justify-center   mt-15 rounded-5 h-40 bg-green-badge text-white text-18 self-center"
                onClick={() => {
                  setBudget(props.total2);
                  setPlan(2);
                  setService('Plan For Fast Growth');
                  document.documentElement.style.overflow = 'hidden';
                  setShowCostumProposalModel(true);
                }}
              >
                I'm ready to invest
              </a>
              <a
                className="max-w-300 mx-15 cursor-pointer hover:bg-green md:mx-0 px-15 flex md:hidden items-center justify-center  mt-15 rounded-5 h-40  bg-green-badge text-white text-18 self-center"
                href={'/paid-advertising-services/order-now?service=' + service + '&budget=' + props.total2}
              >
                I'm ready to invest
              </a>
              <div className="max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">{props.total2}/month ad spend (paid to networks)</span>
              </div>
              <div className="max-w-300 w-90p flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Guaranteed Leads or Purchases</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Campaign development & strategy</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Keyword research and selection</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Industry analysis</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad campaign copywriting</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad Banners Creation (3 banners)</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">15-sec Video Ad Creation</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad Performance Testing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Strategic bid management</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Remarketing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Website conversion analysis reporting</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Monthly Reports & Consultation</span>
              </div>
            </div>
          </div>
        </div>
        <div className=" p-10 md:p-15 shad">
          <div className={'rounded-25'}>
            <div className="rounded-t-25 bg-purple-slider h-296 text-center">
              <p className="pt-20 text-center font-bolder text-24 text-black">
                Plan For Ultra <br /> Growth
              </p>
              <img className="inline-block mx-auto" src="https://admin.weprodigi.com/uploads/files/shares/ppc/plan3.png" alt="plan3" />
              <p className="text-24 text-purple font-800 ">{props.total3} </p>
              <p className="text-16 text-purple italic font-bold"> / Monthly Ad Investment</p>
              <p className=" text-16 font-medium max-w-300 mx-auto mt-10 ">10% management fee from ad spends</p>
            </div>
            <div className="min-h-820  bg-white flex flex-col items-start rounded-b-25 pb-20">
              <a
                className="max-w-300 mx-15 hover:bg-green-hover md:mx-0 w-full hidden md:flex cursor-pointer items-center justify-center   mt-15 rounded-5 h-40 bg-green-badge text-white text-18 self-center"
                onClick={() => {
                  setBudget(props.total3);
                  setPlan(3);
                  setService('Plan For Ultra Growth');
                  document.documentElement.style.overflow = 'hidden';
                  setShowCostumProposalModel(true);
                }}
              >
                I'm ready to invest
              </a>
              <a
                className="max-w-300 mx-15 hover:bg-green-hover md:mx-0 px-15 flex cursor-pointer   md:hidden items-center justify-center   mt-15 rounded-5 h-40  bg-green-badge text-white text-18 self-center"
                href={'/paid-advertising-services/order-now?service=' + service + '&budget=' + props.total3}
              >
                I'm ready to invest
              </a>
              <div className="max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">{props.total3}/month ad spend (paid to networks)</span>
              </div>
              <div className="max-w-300 w-90p flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Guaranteed Leads or Purchases</span>
              </div>
              <div className="max-w-300 w-90p flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Campaign development & strategy</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Keyword research and selection</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Industry analysis</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad campaign copywriting</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad Banners Creation (5 banners)</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">15-sec Video Ad Creation</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">International Campaigns (Non-English) up to 3 languages</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Ad Performance Testing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Google analytics integration & goal tracking</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Strategic bid management</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Remarketing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Website conversion analysis reporting</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Landing page performance testing</span>
              </div>
              <div className=" max-w-300 w-full flex items-center mt-10 pl-15">
                <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" width={15} height={12} alt="check" />
                <span className=" ml-15 text-16">Monthly Reports & Consultation</span>
              </div>
            </div>
          </div>
        </div>
      </Slider>
      {/*<GetCustomProposal country={props.country} show={showCostumProposalModel} hide={hideCostumProposalModal} budget={budget} plan={plan} />*/}
      <GetOrderProposal
        budget={budget}
        currency={props.currency}
        id={'from-plans'}
        country={props.country}
        show={showCostumProposalModel}
        hide={hideCostumProposalModal}
        service={service}
      />

      <div className="flex flex-col md:flex-row justify-center items-center mt-23">
        <p className={'text-24 md:text-28 leading-29 font-bolder text-purple text-center'}>Need more information?</p>
        <a
          href="https://calendar.app.google/uJZkJfztLwHZcfkC7"
          target={'_blank'}
          className={'flex font-medium text-24 md:text-28 leading-29 text-green-badge items-center ml-15 mt-10 md:mt-0'}
        >
          Schedule a call
          <p className={'jello-horizontal'}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6  " fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </p>
        </a>
      </div>
    </>
  );
};
export default PPCPlansSLider;
